import {
    useLocation,
} from 'react-router-dom'

import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import requests from 'app/requests/ActivityRecords.requests'
import ActivityRecordForm from '../ActivityRecordForm'

const ActivityRecordCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    const {
        state,
    } = useLocation()

    return (
        <ActivityRecordForm
            data={state || {}}
            onSuccess={onSuccess}
            requestParam={requests.create()}
        />
    )
}

export default ActivityRecordCreate
